module.exports = __webpack_public_path__ + "img/icon_guide_line.6212b1e2.png";